import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import CriarTarefaModal from '../components/CriarTarefaModal';

const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
const DIAS_SEMANA_FULL = ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];
const DIAS_SEMANA_SHORT = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];

const TIPO_COR = {
  'agenda':'#f6c90e','prazo_vendedor':'#fb923c','visita':'#a78bfa',
  'proxima_acao':'#60a5fa','pagamento':'#4ade80','inicio_projeto':'#2dd4bf',
  'pos_venda_prevista':'#c084fc','pos_venda_conclusao':'#4ade80',
  'eng_inicio':'#f97316','eng_previsao':'#a78bfa',
  'projeto_inicio':'#34d399','projeto_prazo':'#f59e0b',
  'inst_inicio':'#2dd4bf','inst_previsao':'#fb923c','inst_programada':'#60a5fa',
  'pv_transportadora':'#fb923c','pv_inst_inicio':'#2dd4bf','pv_inst_fim':'#4ade80',
};
const TIPO_ICONE = {
  'agenda':'📅','prazo_vendedor':'⏰','visita':'🏠','proxima_acao':'🎯',
  'pagamento':'💰','inicio_projeto':'🚀','pos_venda_prevista':'🔧',
  'pos_venda_conclusao':'✅','eng_inicio':'⚙️','eng_previsao':'✅',
  'projeto_inicio':'🏗️','projeto_prazo':'📆','inst_inicio':'🚀','inst_programada':'🔨',
  'inst_previsao':'✅','pv_transportadora':'🚛','pv_inst_inicio':'🔧','pv_inst_fim':'✅',
};
const TIPO_NOME = {
  'agenda':'Compromisso','prazo_vendedor':'Prazo Vendedor','visita':'Visita Agendada',
  'proxima_acao':'Próxima Ação','pagamento':'Pagamento','inicio_projeto':'Início Projeto',
  'pos_venda_prevista':'Previsão Pós-Venda','pos_venda_conclusao':'Conclusão Pós-Venda',
  'eng_inicio':'Início Engenharia','eng_previsao':'Previsão Engenharia',
  'projeto_inicio':'Início Projeto','projeto_prazo':'Prazo Projeto',
  'inst_inicio':'Início Instalação','inst_previsao':'Previsão Instalação','inst_programada':'Instalação Programada',
  'pv_transportadora':'Chegada Transportadora','pv_inst_inicio':'Início Instalação',
  'pv_inst_fim':'Prev. Fim Instalação',
};

export default function Agenda() {
  const [eventos, setEventos] = useState([]);
  const [mes, setMes]         = useState(new Date().getMonth());
  const [ano, setAno]         = useState(new Date().getFullYear());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  const [dayModal, setDayModal] = useState(null); // { dia, evs }
  const { isChefe, isGerenteComercial, isInstalador, isEngenheiro, isPosVenda, isVendedor } = useAuth();
  const navigate = useNavigate();

  const openDayModal = (dia, evs) => setDayModal({ dia, evs });

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const [erro, setErro] = useState('');
  const [mostrarCriarTarefa, setMostrarCriarTarefa] = useState(false);

  const carregarEventos = () => {
    api.get('/agenda/').then(r => setEventos(r.data)).catch(() => setErro('Erro ao carregar dados. Tente atualizar a página.'));
  };
  useEffect(() => { carregarEventos(); }, []); // eslint-disable-line

  const hoje = new Date();
  const getDate = (e) => new Date(e.data_hora);

  const eventosDoMes = eventos.filter(e => {
    const d = getDate(e);
    return d.getFullYear() === ano && d.getMonth() === mes;
  });

  const eventosNoDia = (dia) => eventos.filter(e => {
    const d = getDate(e);
    return d.getFullYear() === ano && d.getMonth() === mes && d.getDate() === dia;
  });

  const chefe = isChefe() || isGerenteComercial();

  const navAnterior = () => { if (mes === 0) { setMes(11); setAno(a => a-1); } else setMes(m => m-1); };
  const navProximo  = () => { if (mes === 11) { setMes(0); setAno(a => a+1); } else setMes(m => m+1); };

  // Células do calendário
  const primeiroDia    = new Date(ano, mes, 1).getDay();
  const diasNoMes      = new Date(ano, mes+1, 0).getDate();
  const diasAnteriores = new Date(ano, mes, 0).getDate();
  const cells = [];
  for (let i = primeiroDia-1; i >= 0; i--) cells.push({ dia: diasAnteriores-i, inMonth: false });
  for (let d = 1; d <= diasNoMes; d++)     cells.push({ dia: d, inMonth: true });
  while (cells.length % 7 !== 0)           cells.push({ dia: cells.length - diasNoMes - primeiroDia + 1, inMonth: false });

  const getCor = (e) => TIPO_COR[e.origem || 'agenda'] || '#f6c90e';
  const getIcone = (e) => TIPO_ICONE[e.origem || 'agenda'] || '📅';

  // ── Estilos ──────────────────────────────────────────────────────────────
  const S = {
    wrap:     { fontFamily:'inherit' },
    heading:  { fontSize: isMobile ? 20 : 24, fontWeight:700, color:'#f6c90e', marginBottom:4 },
    sub:      { fontSize:13, color:'#475569', marginBottom:16 },
    navRow:   { display:'flex', alignItems:'center', gap:12, marginBottom:16, flexWrap:'wrap' },
    navBtn:   {
      background:'#0e1420', border:'1px solid #1a2035', borderRadius:10,
      padding: isMobile ? '8px 16px' : '7px 18px',
      color:'#94a3b8', cursor:'pointer', fontSize: isMobile ? 16 : 18, fontWeight:700,
      lineHeight:1,
    },
    monthLabel: { fontSize: isMobile ? 15 : 17, fontWeight:700, color:'#e2e8f0', minWidth:160, textAlign:'center' },
    countBadge: { fontSize:12, color:'#475569', marginLeft:'auto' },

    // Grid (desktop)
    grid:     { display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap: isMobile ? 2 : 4 },
    dayHeader:{ textAlign:'center', fontSize:11, color:'#475569', padding:'6px 0', textTransform:'uppercase', letterSpacing:0.5 },
    dayCell:  (isToday, inMonth) => ({
      minHeight: isMobile ? 60 : 110,
      background: isToday ? 'rgba(246,201,14,0.07)' : '#0e1420',
      border: isToday ? '1px solid rgba(246,201,14,0.4)' : '1px solid #1a2035',
      borderRadius: isMobile ? 6 : 10,
      padding: isMobile ? '4px 3px' : '8px 7px',
      opacity: inMonth ? 1 : 0.25,
      overflow: 'hidden',
    }),
    dayNum: (isToday) => ({
      fontSize: isMobile ? 11 : 13,
      fontWeight: isToday ? 800 : 500,
      color: isToday ? '#f6c90e' : '#64748b',
      marginBottom: isMobile ? 2 : 5,
      lineHeight: 1,
    }),
    event: (cor, concluido) => ({
      background: `${cor}1a`,
      border: `1px solid ${cor}55`,
      borderRadius: 5,
      padding: isMobile ? '1px 3px' : '3px 6px',
      fontSize: isMobile ? 9 : 11,
      color: concluido ? '#475569' : cor,
      cursor: 'pointer',
      marginBottom: isMobile ? 1 : 3,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textDecoration: concluido ? 'line-through' : 'none',
      display: 'block',
    }),
    moreChip: { fontSize: isMobile ? 9 : 10, color:'#475569', marginTop:1 },

    // Lista (mobile)
    listWrap:  { display:'flex', flexDirection:'column', gap:10 },
    listDay:   { background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, overflow:'hidden' },
    listDayHdr:{ padding:'10px 14px', display:'flex', alignItems:'center', justifyContent:'space-between',
                 borderBottom:'1px solid #1a2035' },
    listDayNum:{ fontSize:15, fontWeight:700, color:'#e2e8f0' },
    listDayNm: { fontSize:12, color:'#475569' },
    listEvRow: (cor) => ({
      padding:'10px 14px', display:'flex', alignItems:'flex-start', gap:10,
      borderBottom:'1px solid #0f1117',
    }),
    listDot:   (cor) => ({ width:8, height:8, borderRadius:'50%', background:cor, flexShrink:0, marginTop:4 }),
    listTitle: { fontSize:13, color:'#e2e8f0', fontWeight:600, marginBottom:2 },
    listMeta:  { fontSize:11, color:'#475569' },

    // Legenda
    legendaWrap: { display:'flex', flexWrap:'wrap', gap:8, marginBottom:14, padding:'10px 14px',
                   background:'#0e1420', border:'1px solid #1a2035', borderRadius:10 },
    legendaItem: { display:'flex', alignItems:'center', gap:5, fontSize:11, color:'#94a3b8' },
    legendaDot:  (c) => ({ width:8, height:8, borderRadius:'50%', background:c, flexShrink:0 }),
  };

  // Tipos presentes no mês (para legenda)
  const tiposNoMes = [...new Set(eventosDoMes.map(e => e.origem || 'agenda'))];

  // ── Render ───────────────────────────────────────────────────────────────
  return (
    <div style={S.wrap}>
      <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:10, marginBottom:4 }}>
        <div>
          <div style={S.heading}>Agenda</div>
          <div style={S.sub}>
            {chefe ? 'Visão completa — todos os prazos, datas e compromissos do sistema' : 'Seus compromissos e prazos'}
          </div>
        </div>
        <button
          onClick={() => setMostrarCriarTarefa(true)}
          style={{ padding:'9px 18px', borderRadius:9, border:'none', background:'rgba(74,222,128,0.15)', color:'#4ade80', fontSize:13, fontWeight:700, cursor:'pointer', whiteSpace:'nowrap' }}
        >
          + Criar nova tarefa
        </button>
      </div>

      {erro && (
        <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:14 }}>{erro}</div>
      )}

      {mostrarCriarTarefa && (
        <CriarTarefaModal
          onClose={() => setMostrarCriarTarefa(false)}
          onSaved={() => carregarEventos()}
        />
      )}

      {/* Navegação */}
      <div style={S.navRow}>
        <button style={S.navBtn} onClick={navAnterior}>‹</button>
        <span style={S.monthLabel}>{MESES[mes]} {ano}</span>
        <button style={S.navBtn} onClick={navProximo}>›</button>
        <span style={S.countBadge}>{eventosDoMes.length} evento(s) neste mês</span>
      </div>

      {/* ── Modo MOBILE: lista por dia ─────────────────────────────────── */}
      {isMobile ? (
        <div style={S.listWrap}>
          {Array.from({ length: diasNoMes }, (_, i) => i + 1).map(dia => {
            const evs = eventosNoDia(dia);
            if (evs.length === 0) return null;
            const isToday = dia === hoje.getDate() && mes === hoje.getMonth() && ano === hoje.getFullYear();
            const diaSemana = DIAS_SEMANA_FULL[new Date(ano, mes, dia).getDay()];
            return (
              <div key={dia} style={{ ...S.listDay, border: isToday ? '1px solid rgba(246,201,14,0.4)' : '1px solid #1a2035' }}>
                <div style={{ ...S.listDayHdr, background: isToday ? 'rgba(246,201,14,0.07)' : 'transparent' }}>
                  <span style={{ ...S.listDayNum, color: isToday ? '#f6c90e' : '#e2e8f0' }}>{dia}</span>
                  <span style={S.listDayNm}>{diaSemana}</span>
                </div>
                {evs.map(e => {
                  const cor = getCor(e);
                  const hora = new Date(e.data_hora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
                  return (
                    <div key={e.id} style={S.listEvRow(cor)}
                      onClick={() => e.lead_id && navigate('/clientes', { state: { leadId: e.lead_id } })}>
                      <div style={S.listDot(cor)} />
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={S.listTitle}>{e.titulo}</div>
                        <div style={S.listMeta}>
                          {hora}
                          {e.cliente_nome && ` · ${e.cliente_nome}`}
                          {e.responsavel && ` · ${e.responsavel}`}
                        </div>
                      </div>
                      <div style={{ fontSize:11, color: TIPO_COR[e.origem || 'agenda'] || '#f6c90e', flexShrink:0 }}>
                        {TIPO_NOME[e.origem || 'agenda'] || ''}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
          {eventosDoMes.length === 0 && (
            <div style={{ textAlign:'center', color:'#475569', padding:40, fontSize:14 }}>
              Nenhum evento em {MESES[mes]}
            </div>
          )}
        </div>
      ) : (
        /* ── Modo DESKTOP: grade calendário ────────────────────────────── */
        <div style={S.grid}>
          {DIAS_SEMANA_SHORT.map(d => (
            <div key={d} style={S.dayHeader}>{d}</div>
          ))}
          {cells.map((cell, i) => {
            const evs = cell.inMonth ? eventosNoDia(cell.dia) : [];
            const isToday = cell.inMonth && cell.dia === hoje.getDate() && mes === hoje.getMonth() && ano === hoje.getFullYear();
            const MAX_VISIBLE = 3;
            const visible  = evs.slice(0, MAX_VISIBLE);
            const overflow = evs.length - MAX_VISIBLE;
            return (
              <div key={i} style={S.dayCell(isToday, cell.inMonth)}>
                <div
                  style={{ ...S.dayNum(isToday), cursor: evs.length > 0 ? 'pointer' : 'default', display:'inline-block' }}
                  onClick={() => evs.length > 0 && openDayModal(cell.dia, evs)}
                  title={evs.length > 0 ? `Ver todos os ${evs.length} eventos` : undefined}
                >{cell.dia}</div>
                {visible.map(e => {
                  const cor = getCor(e);
                  const icone = getIcone(e);
                  const hora  = new Date(e.data_hora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
                  const label = e.titulo || e.cliente_nome || '';
                  return (
                    <div
                      key={e.id}
                      style={S.event(cor, e.concluido)}
                      onClick={() => e.lead_id && navigate('/clientes', { state: { leadId: e.lead_id } })}
                      title={`${icone} ${e.titulo} — ${hora}${e.responsavel ? ' | '+e.responsavel : ''}`}
                    >
                      {icone} {label}
                    </div>
                  );
                })}
                {overflow > 0 && (
                  <div
                    style={{ ...S.moreChip, cursor:'pointer', color:'#60a5fa' }}
                    onClick={() => openDayModal(cell.dia, evs)}
                  >+{overflow} mais</div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── Modal de dia ──────────────────────────────────────────────────── */}
      {dayModal && (
        <div
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', zIndex:1200,
                   display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
          onClick={e => e.target === e.currentTarget && setDayModal(null)}
        >
          <div style={{ background:'#0e1420', border:'1px solid #1a2035', borderRadius:14,
                        width:'100%', maxWidth:520, maxHeight:'80vh', display:'flex', flexDirection:'column' }}>
            {/* Header */}
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
                          padding:'16px 20px', borderBottom:'1px solid #1a2035' }}>
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:'#f6c90e' }}>
                  {dayModal.dia} de {MESES[mes]} {ano}
                </div>
                <div style={{ fontSize:12, color:'#475569', marginTop:2 }}>
                  {dayModal.evs.length} compromisso{dayModal.evs.length !== 1 ? 's' : ''}
                </div>
              </div>
              <button
                onClick={() => setDayModal(null)}
                style={{ background:'none', border:'none', color:'#64748b', cursor:'pointer', fontSize:20, lineHeight:1 }}
              >×</button>
            </div>
            {/* Lista */}
            <div style={{ overflowY:'auto', flex:1 }}>
              {dayModal.evs.map(e => {
                const cor = getCor(e);
                const icone = getIcone(e);
                const hora = new Date(e.data_hora).toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' });
                return (
                  <div key={e.id}
                    style={{ padding:'12px 20px', borderBottom:'1px solid #0f1117',
                             display:'flex', alignItems:'flex-start', gap:12 }}>
                    {/* Dot */}
                    <div style={{ width:9, height:9, borderRadius:'50%', background:cor,
                                  flexShrink:0, marginTop:5 }} />
                    <div style={{ flex:1, minWidth:0 }}>
                      {/* Tipo */}
                      <div style={{ fontSize:10, color:cor, fontWeight:700, textTransform:'uppercase',
                                    letterSpacing:0.8, marginBottom:3 }}>
                        {icone} {TIPO_NOME[e.origem || 'agenda'] || e.origem}
                        {hora && <span style={{ color:'#475569', fontWeight:400, marginLeft:6 }}>{hora}</span>}
                      </div>
                      {/* Título */}
                      <div style={{ fontSize:13, color: e.concluido ? '#475569' : '#e2e8f0', fontWeight:600,
                                    textDecoration: e.concluido ? 'line-through' : 'none', marginBottom:4 }}>
                        {e.titulo}
                      </div>
                      {/* Cliente — clicável */}
                      {e.cliente_nome && (
                        <button
                          onClick={() => { setDayModal(null); navigate('/clientes', { state: { leadId: e.lead_id } }); }}
                          style={{ background:'none', border:'none', padding:0, cursor:'pointer',
                                   fontSize:12, color:'#60a5fa', textDecoration:'underline',
                                   textUnderlineOffset:2, textAlign:'left' }}
                        >
                          👤 {e.cliente_nome}
                        </button>
                      )}
                      {/* Responsável */}
                      {e.responsavel && (
                        <div style={{ fontSize:11, color:'#475569', marginTop:2 }}>
                          {e.responsavel}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
